import type { BlockKind, VoxelWorld } from "../../types";

export enum StructureId {
    Igloo = "igloo",
    Cabin = "cabin",
    LogPile = "log-pile",
    Watchtower = "watchtower",
    StoneArch = "stone-arch",
    Well = "well",
    Ruin = "ruin",
    SwampHut = "swamp-hut",
    DeadTree = "dead-tree",
    Pyramid = "pyramid",
    MesaMine = "mesa-mine",
    MushroomCircle = "mushroom-circle",
    NetherShrine = "nether-shrine",
}

export interface StructureSpot {
    x: number;
    z: number;
    topAbs: number;
}

export type StructureFootprint = number | { width: number; depth: number };

export type StructureBuilder = (world: VoxelWorld, spot: StructureSpot) => void;

export interface StructureDefinition {
    id: StructureId;
    surfaces: readonly BlockKind[];
    footprint: StructureFootprint;
    build: StructureBuilder;
}

export interface StructurePlacement {
    id: StructureId;
    spot: StructureSpot;
}
